import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import {
  translate,
  defaultTheme,
  ViewTitle,
  SimpleShowLayout,
} from 'admin-on-rest'
import CircularProgress from 'material-ui/CircularProgress'
import { Card } from 'material-ui/Card'
import { crudGetOne as crudGetOneAction } from 'admin-on-rest'
import { CourseView } from '../components/CourseView'
import StudentCoursePageJoin from './StudentCoursePageJoin'
import StudentCoursePageShow from './StudentCoursePageShow'
import StudentCoursePageInProgress from './StudentCoursePageInProgress'

import { getCurrentUserId } from '../helpers'

class StudentCoursePage extends React.Component {
  componentDidMount() {
    this.props.crudGetOne(
      this.props.resource,
      this.props.id,
      this.getBasePath(),
    )
  }

  getBasePath() {
    const { location } = this.props
    return location.pathname
      .split('/')
      .slice(0, -1)
      .join('/')
  }

  render() {
    const { data, translate } = this.props

    // console.log('course page', data)

    if (
      this.props.isLoading ||
      !this.props.data ||
      Object.keys(this.props.data).length === 0
    ) {
      // Data not yet loaded for course
      return (
        <Card>
          <CircularProgress />
        </Card>
      )
    }

    // Basically only the courses you are enrolled should be displayed
    const isEnrolled =
      data.students && data.students.hasOwnProperty(getCurrentUserId())

    switch (this.getBasePath()) {
      case '/course/join':
        return (
          <Card>
            <StudentCoursePageJoin
              course={this.props.data}
              isEnrolled={isEnrolled}
            />
          </Card>
        )
        break

      case '/course/show':
        return (
          <Card>
            <StudentCoursePageShow
              course={this.props.data}
              isEnrolled={isEnrolled}
            />
          </Card>
        )
        break
      case '/course/in-progress':
        return (
          <Card>
            <StudentCoursePageInProgress
              course={this.props.data}
              isEnrolled={isEnrolled}
            />
          </Card>
        )
        break
      default:
        return (
          <Card>
            <StudentCoursePageShow course={this.props.data} />
          </Card>
        )
        break
    }
  }
}

StudentCoursePage.defaultProps = {
  theme: defaultTheme,
}

function mapStateToProps(state, props) {
  return {
    resource: 'courses',
    id: props.match.params.id,
    data:
      state.admin.resources['courses'] &&
      state.admin.resources['courses'].data &&
      state.admin.resources['courses'].data[props.match.params.id]
        ? state.admin.resources['courses'].data[props.match.params.id]
        : {},
    isLoading: state.admin.loading > 0,
  }
}

const enhance = compose(
  translate,
  connect(mapStateToProps, { crudGetOne: crudGetOneAction }),
)

export default enhance(StudentCoursePage)



// WEBPACK FOOTER //
// ./src/students/StudentCoursePage.js